import React from 'react';
import { StyleSheet, View } from 'react-native';

import { ENVELOPE, PX_PER_IN } from '@/components/print/print-type';

/** Clearance between a tick and the content it sits beside. */
const CONTENT_GAP_IN = 0.05;

interface Props {
	/** Where the sheet's box starts on paper (its `@page` top margin), in inches. */
	boxTopIn: number;
	/** The sheet's left/right print padding, in inches — the ticks live in it. */
	sidePadIn: number;
}

/**
 * Barely-there dashed ticks at the two tri-fold lines (`ENVELOPE.foldsIn`), at the left and right
 * edges of the printed area, so a stack of mailers folds where the address lines up with the
 * envelope window. Absolutely positioned from the top of the sheet, so they land on the sheet's
 * first page only (each sheet starts a page). Print-only: `[data-print-only]` is hidden on screen
 * by the print layout (`app/print/_layout.tsx`).
 *
 * They sit in the sheet's side padding (see `PRINT_SIDE_MARGIN_IN`), INSIDE the sheet's width:
 * anything poking out into the `@page` margin makes Chrome shrink the whole page to fit (~4%).
 */
export const FoldTicks: React.FC<Props> = ({ boxTopIn, sidePadIn }) => {
	const width = Math.round((sidePadIn - CONTENT_GAP_IN) * PX_PER_IN);
	return (
		<>
			{ENVELOPE.foldsIn.flatMap((foldIn) => {
				const top = Math.round((foldIn - boxTopIn) * PX_PER_IN);
				return [
					<View key={`${foldIn}-l`} testID="fold-tick" style={[styles.tick, { top, left: 0, width }]} {...({ dataSet: { printOnly: '1' } } as object)} />,
					<View key={`${foldIn}-r`} testID="fold-tick" style={[styles.tick, { top, right: 0, width }]} {...({ dataSet: { printOnly: '1' } } as object)} />,
				];
			})}
		</>
	);
};

const styles = StyleSheet.create({
	tick: {
		position: 'absolute',
		height: 0,
		borderTopWidth: 0.5,
		borderStyle: 'dashed',
		borderColor: '#d9d9d9',
	},
});
